import type { SuggestSuggestionV22 } from '~/types/openapi/search-api'

export type SuggestionOption = SuggestSuggestionV22 & {
  subtitle?: string
}

export function useDestinationSearch(model: Ref<SuggestionOption | undefined>) {
  const query = ref<string>(model.value?.label ?? '')

  const { data: searchOptions, refetch } = useRedesignSearchSuggestions(query)
  const [isOpen, toggle] = useToggle()

  watch(model, () => toggle(false))

  const suggestions = computed<SuggestionOption[]>(() => {
    return (
      searchOptions.value?.map((option) => ({
        ...option,
        subtitle: getSubtitle(option),
      })) ?? []
    )
  })

  function handleFocus() {
    toggle(true)
    if (searchOptions.value?.length) return
    refetch()
  }

  function handleBlur() {
    toggle(false)
  }

  function handleClick() {
    toggle(true)
  }

  const handleInput = useDebounceFn(handleQueryChange, 300)

  function handleQueryChange({ target }: Event) {
    query.value = (target as HTMLInputElement).value
  }

  function handleClear() {
    query.value = ''
    model.value = undefined
  }

  function getSubtitle(option: SuggestSuggestionV22): string {
    if (!option.type || option.type === 'C') return ''

    const words = []

    if (option.type === 'R') {
      words.push(option.country?.label ?? '')
    } else if (option.type === 'P') {
      words.push(option.region?.label ?? '')
      words.push(option.country?.label ?? '')
    } else if (isSuggestionTypeAccom(option.type)) {
      words.push(option.place?.label ?? '')
      words.push(option.region?.label ?? '')
      words.push(option.country?.label ?? '')
    }

    return words.join(', ')
  }

  return {
    query,
    suggestions,
    isOpen,
    toggle,
    handleFocus,
    handleBlur,
    handleClick,
    handleInput,
    handleQueryChange,
    handleClear,
  }
}
